<template>
  <v-container class="mb-12">
    <v-row justify="center">
      <Logo></Logo>
    </v-row>

    <h1 class="text-center mb-4">Downloads</h1>

    <v-row justify="center">
      <v-col sm="4">
        <v-select
            v-model="selectedSpecies"
            :items="species"
            item-text="name"
            item-value="id"
            label="Species"
            outlined
            hint="Choose a species"
            persistent-hint
        ></v-select>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-checkbox color="primary" v-model="top6" class="mx-2" label="Top 6 sgRNA per gene"></v-checkbox>
      <v-checkbox color="primary" v-model="all" class="mx-2" label="Genome wide prediction"></v-checkbox>
    </v-row>
    <v-row justify="center">
      <v-btn @click="downloadFile" color="primary" class="mt-2" large :disabled="disabled">Download</v-btn>
    </v-row>

    <v-row justify="center">
      <v-col sm="4">
        <v-progress-linear
            color="primary"
            height="8"
            :value="progress"
            :active="downloadActive"
            rounded
            class="mt-4"
        ></v-progress-linear>
      </v-col>
      <v-col
          class="subtitle-1 text-center pt-0"
          cols="12"
          v-if="downloadActive"
      >
        {{downloadStatus}}
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import Logo from '../components/Logo';
  import api from '../api';

  export default {
    name: 'Download',
    components: {
      Logo
    },
    data() {
      return {
        selectedSpecies: '',
        top6: true,
        all: true,
        progress: 0,
        downloadActive: false,
        downloadStatus: '',
        disabled: false
      }
    },
    computed: {
      ...mapState([
        'species',
        'filter'
      ])
    },
    watch: {
      all(val) {
        this.disabled = !val && !this.top6;
      },
      top6(val) {
        this.disabled = !this.all && !val;
      }
    },
    created() {
      this.selectedSpecies = this.filter.species;
    },
    methods: {
      ...mapActions([
        'addNotification'
      ]),

      downloadFile() {
        if (!this.downloadActive) {
          if (this.all && this.top6) {
            this.download(true)
              .then(() => this.download());
          } else {
            if (this.all || this.top6) {
              this.download(this.top6);
            }
          }
        } else {
          this.addNotification({ text: 'Download in progress!' })
        }
      },

      download(top6 = false) {
        this.downloadActive = true;
        this.downloadStatus = top6 ? 'Download top 6 sgRNA per gene...' : 'Download genome wide prediction...';
        const filename = top6 ? `${this.selectedSpecies}_top6_sgRNAs.txt.zip` : `${this.selectedSpecies}_all_sgRNAs.txt.zip`;

        return new Promise(resolve => {
          api.download(filename).subscribe({
            next: progress => this.progress = progress,
            complete: () => {
              setTimeout(() => {
                this.downloadActive = false;
                this.progress = 0;
                resolve();
              }, 800)
            }
          });
        });
      }
    }
  }
</script>
